import { render } from "./TraineePanelView.vue?vue&type=template&id=1b24d966&scoped=true"
import script from "./TraineePanelView.vue?vue&type=script&lang=js"
export * from "./TraineePanelView.vue?vue&type=script&lang=js"

import "./TraineePanelView.vue?vue&type=style&index=0&id=1b24d966&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b24d966"]])

export default __exports__